import type { ArdoqId } from '@ardoq/api-types';
import type { ParamHandler } from 'router/declarative/paramRegistry';

const ardoqIdParam = {
  fromString: (value: string): ArdoqId => value,
  toString: (value: ArdoqId): string => value,
} satisfies ParamHandler<ArdoqId>;

export const presentationParamDeclarations = {
  presentationId: ardoqIdParam,
  selectedSlide: ardoqIdParam,
  context: ardoqIdParam,
} as const;
